import { unwrap } from '@/lib/apiEnvelope'
import { httpClient } from '@/lib/httpClient'
import type { ApiResponse, Paginated } from '@/types/api'

import type { MeuEvento, MeuEventoListFilters } from '../types/meuEvento'

export const meusEventosApi = {
  list: async (filters: MeuEventoListFilters): Promise<Paginated<MeuEvento>> => {
    const params: Record<string, string | number | boolean> = {
      page: filters.page,
      pageSize: filters.pageSize,
    }
    if (filters.apenasNaoVisualizados) params.apenasNaoVisualizados = true
    const response = await httpClient.get<ApiResponse<Paginated<MeuEvento>>>('/meus-eventos', {
      params,
    })
    return unwrap(response)
  },

  marcarVisualizado: async (id: string): Promise<void> => {
    await httpClient.patch(`/meus-eventos/${id}/visualizar`)
  },
}
